import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import chevronDown from '@/public/images/icons/chevron-down.svg';

import style from './style.module.scss';

const PromotionDropdown = (props: any) => {
  const { unit, onSelect, promotionError, locale, isMultiPromo } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const dropdownRef = useRef(null);

  const { promotionList } = unit;

  useEffect(() => {
    setSelectedPromotion(promotionList[0]);
    onSelect(promotionList[0]);
  }, [unit]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handlePromotionClick = (promotion: any) => {
    setSelectedPromotion(promotion);
    setIsOpen(false);
    onSelect(promotion);
  };

  const badgeId = (promotion: any) => {
    if (locale === 'fr') return promotion?.badgeFr;
    if (locale === 'en') return promotion?.badgeEn;
    return null;
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={style.promotionDropdown} ref={dropdownRef}>
      {promotionError && (
        <div className={style.errorText}>
          <FormattedMessage id="pleaseApplyPromotion" />
        </div>
      )}
      <div
        className={
          isOpen
            ? `${style.applyPromotionOpen} ${style.applyPromotion} ${
                selectedPromotion ? style.selected : ''
              }`
            : `${style.applyPromotion} ${
                selectedPromotion ? style.selected : ''
              } ${promotionError ? style.promotionError : ''}`
        }
        onClick={toggleDropdown}
      >
        <div className={style.applyPromotionTextContainer}>
          {selectedPromotion ? (
            <div className={style.selectedPromotion}>
              <span
                className={
                  selectedPromotion?.badgeEn && isMultiPromo === true
                    ? style.applyPromotionText
                    : style.applyPromotionTextFull
                }
              >
                {locale === 'en' ? selectedPromotion.en : selectedPromotion.fr}
              </span>
              {selectedPromotion?.badgeEn && (
                <span className={`${style.tag} ${style.promotionAnimation}`}>
                  {<FormattedMessage id={badgeId(selectedPromotion)} />}
                </span>
              )}
            </div>
          ) : (
            <div className={style.noPromotionText}>
              <FormattedMessage id="applyPromotion" />
            </div>
          )}
        </div>
        {promotionList.length > 1 && (
          <div className={style.arrow}>
            <img src={chevronDown.src} alt="chevron-down" />
          </div>
        )}
      </div>
      <div
        className={
          isOpen
            ? `${style.dropdownContent} ${style.open}`
            : style.dropdownContent
        }
        style={{ maxHeight: isOpen ? `${promotionList.length * 48}px` : '0px' }}
      >
        {promotionList.map((promotion: any, key: any) => (
          <div
            className={style.promotionOption}
            key={key}
            onClick={() => handlePromotionClick(promotion)}
          >
            <span className={style.promotionText}>
              {locale === 'en' ? promotion.en : promotion.fr}
            </span>
            {promotion?.badgeEn && (
              <span className={style.tag}>
                {<FormattedMessage id={badgeId(promotion)} />}
              </span>
            )}
          </div>
        ))}
      </div>
      {promotionError && (
        <div
          className={`${style.secondaryErrorText} ${
            isOpen ? style.secondaryErrorTextNone : ''
          }`}
        >
          <FormattedMessage id="pleaseApplyPromotion" />
        </div>
      )}
    </div>
  );
};

export default PromotionDropdown;
